var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import styled from "styled-components";
import Flex from "../../templates/flex";
import { Icon } from "../../icon";
import { Text } from "../../typography";
var MenuContainer = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var MenuButton = forwardRef(function (_a, ref) {
    var open = _a.open, icon = _a.icon, label = _a.label, caret = _a.caret, rest = __rest(_a, ["open", "icon", "label", "caret"]);
    return (React.createElement(MenuContainer, __assign({ gap: 2, padding: [2, 4], justifyContent: "between", alignItems: "center", role: "button", tabindex: "0", "aria-haspopup": "listbox", "aria-expanded": open, ref: ref }, rest),
        React.createElement(Flex, { alignItems: "center", gap: 2 },
            icon,
            typeof label === "string" ? React.createElement(Text, null, label) : label),
        caret === true ? (React.createElement(Icon, { name: "chevron_down", color: "text", width: "12px", height: "12px", rotate: open ? 2 : null })) : (caret)));
});
export default MenuButton;
var templateObject_1;
